/* unplugin-vue-components disabled */import { render } from "./ShareIos.vue?vue&type=template&id=7ee7d046"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__